import { render, staticRenderFns } from "./ZPM.vue?vue&type=template&id=7040fe97&"
import script from "./ZPM.vue?vue&type=script&lang=js&"
export * from "./ZPM.vue?vue&type=script&lang=js&"
import style0 from "./ZPM.vue?vue&type=style&index=0&id=7040fe97&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports